import React from 'react'
import { SortDirection } from '@tanstack/react-table'
import { Icon2 } from '@elamajs/ui-kit'

import * as Styled from './SortableCellContent.styled'

type SortableProps = {
  direction: SortDirection | false
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const Sortable: React.FC<SortableProps> = ({ direction, children, onClick }) => (
  <Styled.Button type="button" onClick={onClick}>
    {children}
    <Styled.ToggleIcon
      as={Icon2}
      icon="arrowDown"
      color={direction === false ? '#A3ABC2' : '#22252A'}
      direction={direction}
    />
  </Styled.Button>
)

export default Sortable
